<mat-expansion-panel [expanded]="true" [disabled]="true">
    <mat-expansion-panel-header  class="mat-header">
        <opt-question-header [dates]="dates" [isMandatory]="bookingQues?.question?.mandatory" [questionNumber]="questionNumber" [questionText]="bookingQues?.question?.questionText" (popselectedDates)="RecveselectedDates($event)"></opt-question-header>
    </mat-expansion-panel-header>
    <div class="wp_flex--container flex-column">
        <div class="wp_flex__item--inherit wp_flex__item--vcenter" style="flex-direction: column; align-items: baseline;">
            <mat-form-field class="">
                <input id="{{bookingQues?.id}}" matInput placeholder="" (input)="inputChanged($event)" [(ngModel)]="bookingQues.answer">
                
            </mat-form-field>
            <br/>
            <div>
                <input 
                *ngIf="bookingQues?.question?.allowUndecided" 
                type="checkbox" 
                [checked]="bookingQues?.question?.undecided" 
                (change)="inputCheckChanged($event)" 
                [(ngModel)]="bookingQues.question.undecided">
                <label class="ml-2" *ngIf="bookingQues?.question?.allowUndecided"> {{'ATTENDEE.Answer later' | optimotranslate }}</label>
            </div>
        </div>
    </div>
</mat-expansion-panel>
